import cities_v2 from './cities_v2.json';

let list = [];

// type: object
for (let provinceName in cities_v2)
{
    let provinceItem = {
        text : provinceName,
        value : provinceName,
        children : []
    };

    // type: object
    let cities = cities_v2[provinceName];

    // type: array
    for (let cityName in cities)
    {
        let cityItem = {
            text : cityName,
            value : cityName,
            children : []
        };
        for (let areaIndex in cities[cityName])
        {
            let areaItem = {
                text : cities[cityName][areaIndex],
                value : cities[cityName][areaIndex],
                // children : []
            }
            cityItem.children.push(areaItem);
        }
        provinceItem.children.push(cityItem);
    }

    list.push(provinceItem);
}

export default list;
